import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import DiseaseApi from 'api/DiseaseApi';
import UserApi from 'api/UserApi';
import { showNotification } from 'app-redux/notification.saga';
import * as dto from 'client/dto';

import {
  loadAllDiseasesError,
  loadAllDiseasesStart,
  loadAllDiseasesSuccess,
  loadAvailableDiseasesSuccess,
  loadDiseaseInfoError,
  loadDiseaseInfoSuccess,
} from './diseases.slice';

export const fetchDiseases = createAction('diseases/fetchDiseases');
export const fetchDiseaseInfo = createAction<number>('diseases/fetchDiseaseInfo');
export const fetchAllAvailableDiseases = createAction('diseases/fetchAllAvailableDiseases');

export function* fetchDiseasesSaga() {
  try {
    yield put(loadAllDiseasesStart());
    const response: dto.DiseaseInformationModel[] = yield call(UserApi.getDiseases);
    yield put(loadAllDiseasesSuccess(response));
  } catch (e) {
    yield put(loadAllDiseasesError());
  } finally {
    yield put({ type: 'FETCH_DISEASES_FINISH' });
  }
}

export function* fetchDiseaseInfoSaga(action: PayloadAction<number>) {
  const diseaseId = action.payload;

  try {
    const res: dto.DiseaseInformationModel = yield call(DiseaseApi.getDisease, diseaseId);
    yield put(loadDiseaseInfoSuccess(res));
  } catch (e) {
    yield put(loadDiseaseInfoError());
  }
}

export function* fetchAllAvailableDiseasesSaga() {
  try {
    yield put(loadAllDiseasesStart());
    const res = yield call(DiseaseApi.getAllDiseases);
    yield put(loadAvailableDiseasesSuccess(res));
  } catch (e) {
    yield put(loadAllDiseasesError());
    yield put(
      showNotification({ type: 'SHOW_ERROR_NOTIFICATION', payload: 'Error fetching diseases' })
    );
  }
}

function* diseasesSaga() {
  yield takeLatest(fetchDiseases, fetchDiseasesSaga);
  yield takeLatest(fetchDiseaseInfo, fetchDiseaseInfoSaga);
  yield takeLatest(fetchAllAvailableDiseases, fetchAllAvailableDiseasesSaga);
}

export default diseasesSaga;
